"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var EventQueue_1 = __importDefault(require("./EventQueue"));
/* eslint-disable no-use-before-define */
var EventFlow = function (_a) {
    var _b = _a === void 0 ? {} : _a, onTokenExpired = _b.onTokenExpired, apiCallFunc = _b.apiCallFunc, errorReport = _b.errorReport, _c = _b.ideal, ideal = _c === void 0 ? constants_1.DEFAULT_IDEAL : _c, _d = _b.retryTimes, retryTimes = _d === void 0 ? constants_1.DEFAULT_RETRY_TIMES : _d, _e = _b.retryIdeal, retryIdeal = _e === void 0 ? constants_1.RETRY_IDEAL : _e, _f = _b.enableBatching, enableBatching = _f === void 0 ? false : _f;
    var eventQueue = EventQueue_1.default();
    var timerId = null;
    var isTokenExpired = false; // eslint-disable-line
    if (typeof apiCallFunc !== 'function') {
        throw new Error('apiCallFunc is required');
    }
    return {
        getEventsQueue: eventQueue.getEventsQueue,
        addEvent: addEvent,
        flushEvents: flushEvents,
    };
    function addEvent(eventObject) {
        eventQueue.pushEvent(eventObject);
    }
    function flushEvents() {
        if (!eventQueue.isEmpty()) {
            var events_1 = eventQueue.popEvents();
            sendOut(events_1).catch(function (err) {
                if (err.isValid === false || err.retryFailed) {
                    if (err.retryFailed) {
                        eventQueue.pushEvents(events_1);
                    }
                    var errorObject = {
                        err: err,
                        current: events_1,
                        time: Date.now(),
                    };
                    console.error('events infomation:', errorObject);
                    errorReport && errorReport.push(errorObject);
                }
                else {
                    eventQueue.pushEvents(events_1);
                }
            });
        }
    }
    function startTimer() {
        if (enableBatching) {
            timerId = setTimeout(function () {
                flushEvents();
                resetTimer();
            }, ideal);
        }
    }
    function resetTimer() {
        if (enableBatching) {
            if (timerId) {
                clearTimeout(timerId);
            }
            startTimer();
        }
    }
    function sendOut(events) {
        return new Promise(function (resolve, reject) {
            retry(function () {
                return apiCallFunc &&
                    apiCallFunc(events).then(function (result) {
                        isTokenExpired = false;
                        return result;
                    });
            }, retryTimes, resolve, reject);
        });
    }
    function retry(funcCall, retryTimesParam, resolve, reject) {
        try {
            funcCall()
                .then(resolve)
                .catch(function (err) {
                if (err.status === 401) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    isTokenExpired = true;
                    onTokenExpired &&
                        onTokenExpired(function () {
                            flushEvents();
                        });
                    reject(err);
                }
                else if (err.status >= 400) {
                    if (err.result && err.result.isValid === false) {
                        reject(__assign(__assign({}, err), { isValid: false }));
                        return;
                    }
                    if (retryTimesParam > 0) {
                        setTimeout(function () {
                            retry(funcCall, retryTimesParam - 1, resolve, reject);
                        }, retryIdeal);
                    }
                    else {
                        console.error("events infomation: Still failed after " + retryTimes + " times retry", err);
                        reject(__assign(__assign({}, err), { retryFailed: true }));
                    }
                }
                else {
                    console.error('events infomation:', err);
                    reject(err);
                }
            });
        }
        catch (e) {
            console.error('events infomation:', e);
            reject(e);
        }
    }
};
exports.default = EventFlow;
//# sourceMappingURL=EventFlow.js.map